var hexRgb = require('hex-rgb');

function buildRgbaString(rgb, a) {
	return `rgba(${rgb.join(',')},${a})`;
}

module.exports = function rgba() {
	var rgb = [0, 0, 0], a = 0;
	if(arguments.length === 1) {
		rgb = hexRgb(arguments[0]);
	} else if(arguments.length === 2) {
		rgb = hexRgb(arguments[0]);
		a = arguments[1];
	} else if(arguments.length === 4) {
		rgb = Array.prototype.slice.call(arguments, 0, 3);
		a = arguments[3];
	}

	return buildRgbaString(rgb, a);
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/rgba.js
 **/